import React from "react";
import '../TreePlantation/treeplantation.css';
import banner1 from '../../assets/treeS.jpg'; // Replace with your image paths
import imageLeft from '../../assets/treeSB4.jpg';
import imageleft2 from'../../assets/organic-farming.jpeg';
import imageRight from '../../assets/treeSB.jpeg';
import banner2 from '../../assets/treeSB1.jpg';

const TreePlantation = () => {
  return (
    <div className="tree-plantation-section">
      {/* Full-width Banner */}
      <div className="banner full-width">
        <img src={banner1} alt="Banner for Tree Plantation" loading="lazy" srcSet={`${banner1} 1x, ${banner1.replace('.jpg', '@2x.jpg')} 2x`}  />
      </div>

      {/* Intro Paragraph */}
      <div className="content">
        <h2>Salaiban Initiative: Restoring the Satpuda Forest Ecosystem</h2>
        <p>
          The Salaiban Initiative, led by the Tarunai Foundation, is a dedicated effort to preserve and rejuvenate
          the rich but endangered forest ecosystem of the Satpuda region. Once a thriving biodiversity hotspot,
          the area was home to over 60 species of trees and plants with immense ecological and medicinal value.
          However, years of deforestation, unregulated grazing, and the pressures of unsustainable tourism have
          severely degraded the forest, putting its unique flora and fauna at risk.
        </p>
      </div>

      {/* Left Image - Right Content */}
      <div className="content-section">
        <div className="image-container">
          <img src={imageLeft} alt="Tree Plantation Efforts" 
               loading="lazy"
               srcSet={`${imageLeft} 1x, ${imageLeft.replace('.jpg', '@2x.jpg')} 2x`}/>
      
        </div>
        <div className="text-container">
          <h3>Key Objectives of the Salaiban Initiative</h3>
          <ol>
            <li><strong>Afforestation and Reforestation:</strong>
              <ul>
                <li>Large-scale planting of medicinal and native trees, including Arjuna<i>(Terminalia arjuna)</i>, Gugul<i>(Commiphora wightii)</i>, Banyan, Mahua<i>(Madhuca longifolia)</i>, Jamun<i>(Syzygium cumini)</i>, and other indigenous species.</li>
                <li>Focus on species with ecological and medicinal significance to restore the forest's biodiversity.</li>
              </ul>
            </li>
            <li><strong>Biodiversity Restoration:</strong> 
                <ul>
                    <li>Revival of plant species that are vital to the region’s ecological balance and traditional medicine practices.</li>
                    <li>Prevention of the extinction of endangered flora through systematic protection and propagation.</li>
                </ul>
            </li>
            <li><strong>Community Awareness and Engagement:</strong> 
                <ul>
                    <li>Organizing workshops and awareness campaigns to educate local communities, tourists, and stakeholders about the importance of preserving forest resources.</li>
                    <li>Involving tribal and local populations in sustainable forest management practices.</li>
                </ul>
            </li>
            <li><strong>Combatting Degradation:</strong>
                <ul>
                    <li>Implementing measures to address deforestation, regulate grazing, and mitigate the negative impacts of tourism.</li>
                    <li>Establishing controlled zones to ensure sustainable forest use.</li>
                </ul>
            </li>
          </ol>
        </div>
      </div>

      {/* Right Image - Left Content */}
      <div className="content-section reverse">
        <div className="text-container">
          <h3>Planned Activities and Impact</h3>
          <ol>
            <li><strong>Afforestation Campaigns:</strong> 
               <ul>
                 <li>Thousands of saplings are planted annually to rebuild the forest canopy.</li>
                 <li>Focus on trees that support both ecological processes and traditional livelihoods, such as <strong>honey collection and herbal medicine preparation.</strong>
                 </li>
               </ul>
            </li>
            <li><strong>Medicinal Significance:</strong> 
                
                 <ul>
                    <li>Restoring species like <b>Gugul</b> (a source of resin with anti-inflammatory properties) and <b>Jamun</b> (valued for its medicinal and nutritional benefits) contributes to the revival of ancient healing practices.</li>
                    <li>Preservation of this biodiversity supports long-term research and sustainable use of natural resources.</li>
                 </ul>
            </li>
            <li><strong>Sustainable Development:</strong> 
                <ul>
                  <li>Promoting eco-friendly tourism and providing local communities with alternative income sources such as nursery development and guided forest tours.</li>
                  <li>Supporting sustainable agricultural practices alongside forest conservation.</li>
                </ul>
            </li>
            <li><strong>Biodiversity Monitoring:</strong> 
               <ul>
                 <li>Regular surveys to monitor plant and animal diversity, ensuring that conservation goals are met.</li>
               </ul>
            </li>
          </ol>
        </div>
        <div className="image-container">
          <img src={imageRight} alt="Tree Plantation Activities"  
            loading="lazy"
            srcSet={`${imageRight} 1x, ${imageRight.replace('.jpg', '@2x.jpg')} 2x`}
          />
          <img src={imageleft2} alt="Tree Plantation Efforts"  loading="lazy"
            srcSet={`${imageleft2} 1x, ${imageleft2.replace('.jpeg', '@2x.jpeg')} 2x`}
           />
        </div>
      </div>

      {/* Full-width Banner with Paragraph */}
      <div className="banner full-width">
        <img src={banner2} alt="Banner for Forest Ecosystem"  loading="lazy"
          srcSet={`${banner2} 1x, ${banner2.replace('.jpg', '@2x.jpg')} 2x`}/>
      </div>
      <div className="content">
        <h3>The Bigger Picture: A Forest for Future Generations</h3>
        <p>
          The Salaiban Initiative is not just about planting trees; it is a comprehensive effort to restore the ecological balance of the Satpuda region while respecting its cultural and medicinal heritage. By integrating scientific methods, traditional knowledge, and community participation, the project aims to create a forest that thrives for generations to come.
        </p>
        <p>
            Through collaboration with local stakeholders and continued dedication, the Tarunai Foundation seeks to ensure that the Satpuda forests remain a vital and vibrant ecosystem, benefiting both the environment and the people who depend on it.
        </p>
      </div>
    </div>
  );
};

export default TreePlantation;
